<template>
  <div class="bottomCon">
    <!-- Part2 点位分析 -->
    <div class="bottom Part2">
      <home-part :title="t('pointAnalysis')" :ETitle="'Point Analysis'">
        <template #icon>
          <IconSet name="target" />
        </template>
        <template #content>
          <SkeletonLoader v-if="loading" mode="mixed" />
          <div v-else class="hr">
            <!-- 企业分析饼图 -->
            <!-- 企业分析饼图 -->
            <div class="hr-pie">
              <PieCard :data="pieData">
                <template #center>
                  <div class="bignum">
                    <count-to :start-val="0" :end-val="monitorTotal || 0" :duration="4000" />
                  </div>
                  <div class="textFont">{{ t('PointNum') }}</div>
                </template>
                <template #legend>
                    <div class="pie-legend">
                    <div class="pie-legend__item">
                      <span class="pie-legend__dot" style="background:#6FC98F"></span>
                      <span class="pie-legend__name">{{ t('safePoint') }}</span>
                      <span class="pie-legend__num">{{ safeMonitorCount }}</span>
                    </div>
                    <div class="pie-legend__item">
                      <span class="pie-legend__dot" style="background:#D4895A"></span>
                      <span class="pie-legend__name">{{ t('hiddenPoint') }}</span>
                      <span class="pie-legend__num">{{ riskMonitorCount }}</span>
                    </div>
                  </div>
                </template>
              </PieCard>
            </div>

            <!-- 中高危点位饼图 -->
            <div class="hr-pie">
              <PieCard :data="highRiskData">
                <template #center>
                  <div class="bignum">
                    <count-to :start-val="0" :end-val="hmPoints || 0" :duration="4000" />
                  </div>
                  <div class="textFont">{{ t('hmPoint') }}</div>
                </template>
                <template #legend>
                  <div class="pie-legend">
                    <div class="pie-legend__item point-clickable" @click="$emit('pie-click', { type: 'highRisk', item: { name: t('highPoint'), value: hrPoint } })">
                      <span class="pie-legend__dot" style="background:#DC5A5A"></span>
                      <span class="pie-legend__name">{{ t('highPoint') }}</span>
                      <span class="pie-legend__num">{{ hrPoint }}</span>
                    </div>
                    <div class="pie-legend__item point-clickable" @click="$emit('pie-click', { type: 'highRisk', item: { name: t('midPoint'), value: midPoint } })">
                      <span class="pie-legend__dot" style="background:#D4A34A"></span>
                      <span class="pie-legend__name">{{ t('midPoint') }}</span>
                      <span class="pie-legend__num">{{ midPoint }}</span>
                    </div>
                  </div>
                </template>
              </PieCard>
            </div>

          </div>
        </template>
      </home-part>
    </div>

    <!-- Part1 隐患设备 -->
    <div class="bottom Part1">
      <home-part :title="t('hiddenEquipment')" :ETitle="'Hidden Hazard Equipment'">
        <template #icon>
          <IconSet name="lock-device" />
        </template>
        <template #more>
          <div class="getMore" @click="$emit('getMore')">{{ t('more') }}</div>
        </template>
        <template #content>
          <SkeletonLoader v-if="hiddenLoading" mode="pie" />
          <div v-else class="hidden-box">
            <div class="hidden">
              <div class="hidden-stat">
                <div class="hidden-stat__icon">
                  <svg width="16" height="16" viewBox="0 0 28 28" fill="none">
                    <circle cx="14" cy="14" r="8" stroke="#77A8FF" stroke-width="2"/>
                    <circle cx="14" cy="14" r="3" stroke="#77A8FF" stroke-width="1.5"/>
                    <g stroke="#77A8FF" stroke-width="2.5" stroke-linecap="round">
                      <line x1="14" y1="6" x2="14" y2="4"/>
                      <line x1="14" y1="22" x2="14" y2="24"/>
                      <line x1="6" y1="14" x2="4" y2="14"/>
                      <line x1="22" y1="14" x2="24" y2="14"/>
                      <line x1="19.5" y1="8.5" x2="21" y2="7"/>
                      <line x1="8.5" y1="8.5" x2="7" y2="7"/>
                      <line x1="19.5" y1="19.5" x2="21" y2="21"/>
                      <line x1="8.5" y1="19.5" x2="7" y2="21"/>
                    </g>
                  </svg>
                </div>
                <div class="hidden-stat__info">
                  <div class="hidden-stat__value">
                    <count-to :start-val="0" :end-val="hiddenEquipmentNum || 0" :duration="3000" />
                  </div>
                  <div class="hidden-stat__label">有隐患设备点位</div>
                </div>
              </div>
              <div class="hidden-pie">
                <PieCard :data="hiddenData">
                  <template #center>
                    <div class="bignum" style="color: white">
                      <count-to :start-val="0" :end-val="totalTypePoint || 0" :duration="3000" />
                    </div>
                    <div class="textFont">{{ t('hiddenEquipmentNum') }}</div>
                  </template>
                  <template #legend>
                    <div class="pie-legend">
                    <div class="pie-legend__item">
                      <span class="pie-legend__dot" style="background:#73D0FF"></span>
                      <span class="pie-legend__name">{{ t('powerPoint') }}</span>
                      <span class="pie-legend__num">{{ powerPoint }}</span>
                    </div>
                    <div class="pie-legend__item">
                      <span class="pie-legend__dot" style="background:#D99A5C"></span>
                      <span class="pie-legend__name">{{ t('heatPoint') }}</span>
                      <span class="pie-legend__num">{{ heatPoint }}</span>
                    </div>
                    <div class="pie-legend__item">
                      <span class="pie-legend__dot" style="background:#8B8B8B"></span>
                      <span class="pie-legend__name">其他</span>
                      <span class="pie-legend__num">{{ otherPoint }}</span>
                    </div>
                  </div>
                  </template>
                </PieCard>
              </div>
            </div>
          </div>
        </template>
      </home-part>
    </div>

    <!-- Part4 处置分析 -->
    <div class="bottom Part4">
      <home-part :title="'上月严重点位处置率'" :ETitle="'Disposal Analysis'">
        <template #icon>
          <IconSet name="warning-triangle" />
        </template>
        <template #content>
          <SkeletonLoader v-if="disposalLoading" mode="pie" />
          <div v-else class="hr">
            <div class="hr-pie">
              <PieCard :data="handleRateData">
                <template #center>
                  <div class="bignum">
                    {{ disposedSiteCount === 0 ? '0%' : (lastMonthHandleRate || 0) < 1 ? '< 1%' : (lastMonthHandleRate || 0) + '%' }}
                  </div>
                </template>
                <template #legend>
                  <div class="pie-legend">
                    <div class="pie-legend__item">
                      <span class="pie-legend__dot" style="background:#6FC98F"></span>
                      <span class="pie-legend__name">{{ t('handledPoint') }}</span>
                      <span class="pie-legend__num">{{ handledPoint }}</span>
                    </div>
                    <div class="pie-legend__item">
                      <span class="pie-legend__dot" style="background:#CC6E6E"></span>
                      <span class="pie-legend__name">{{ t('unhandledPoint') }}</span>
                      <span class="pie-legend__num">{{ unhandledPoint }}</span>
                    </div>
                  </div>
                </template>
              </PieCard>
            </div>
          </div>
        </template>
      </home-part>
    </div>

    <!-- Part3 隐患推送 -->
    <div class="bottom Part3">
      <home-part :title="t('hiddenPush')" :ETitle="'Hidden danger push'">
        <template #icon>
          <IconSet name="info-circle" />
        </template>
        <template #more>
          <div class="getMore" @click="$emit('getPushMore')">{{ t('more') }}</div>
        </template>
        <template #content>
          <SkeletonLoader v-if="riskLoading" mode="list" />
          <div v-else class="listCon2" style="margin-top:10px;">
            <div class="listItem bluebg">
              <span class="firsp">#</span>
              <span class="secsp">{{ t('hiddenTime') }}</span>
              <span class="thisp">{{ t('hiddenPlace') }}</span>
              <span class="forsp">{{ t('hiddenName') }}</span>
            </div>

            <vue-seamless-scroll :data="riskList" :class-option="classOption" class="warp">
              <div class="listItem trFont" v-for="(item,index) in riskList" :key="index">
                <span class="firsp">
                  <IndexBadge>{{ index+1 }}</IndexBadge>
                </span>
                <span class="secsp">{{ item.createTime }}</span>
                <span class="thisp">{{ item.deptNameLink.join(',') }}</span>
                <span class="forsp">{{ item.simpleMess }}</span>
              </div>
            </vue-seamless-scroll>
          </div>
        </template>
      </home-part>
    </div>
  </div>
</template>

<script>
import HomePart from "@/components/h5/homePart.vue";
import PieCard from "@/components/h5/PieCard.vue";
import CountTo from 'vue-count-to';
import vueSeamlessScroll from "vue-seamless-scroll";
import IndexBadge from "@/components/h5/IndexBadge.vue";
import IconSet from "@/components/h5/IconSet.vue";
import SkeletonLoader from "@/components/h5/SkeletonLoader.vue"

import { globalI18n } from '@/scripts/i18n'

export default {
  components:{
    HomePart,
    PieCard,
    CountTo,
    vueSeamlessScroll,
    IndexBadge,
    IconSet,
    SkeletonLoader,
  },
  props: {
    hiddenData: { type: Array,  default: ()=>[] },
    equipmentData: { type: Array,  default: ()=>[] },
    highRiskData: { type: Array,  default: ()=>[] },
    pieData: { type: Array,  default: ()=>[] },
    combinedData:  { type: Array,  default: ()=>[] },
    riskList: { type: Array,  default: ()=>[] },
    totalTypePoint: { type: [String,Number], default: 0 },
    pointTotal: { type: [String,Number], default: 0 },
    powerPoint: { type: [String,Number], default: 0 },
    heatPoint: { type: [String,Number], default: 0 },
    otherPoint: { type: [String,Number], default: 0 },
    hiddenEquipmentNum: { type: [String,Number], default: 0 },
    unHiddenEquipmentNum: { type: [String,Number], default: 0 },
    hmPoints: { type: Number, default: 0 },
    hrPoint: { type: Number, default: 0 },
    midPoint: { type: Number, default: 0 },
    monitorTotal: { type: Number, default: 0 },
    safeMonitorCount: { type: Number, default: 0 },
    riskMonitorCount: { type: Number, default: 0 },
    lastMonthHandleRate: { type: Number, default: 0 },
    handledPoint: { type: Number, default: 0 },
    unhandledPoint: { type: Number, default: 0 },
    disposedSiteCount: { type: Number, default: 0 },
    riskSiteCount: { type: Number, default: 0 },
    classOption: { type: Object,  default: ()=>({direction:1,step:0.2,limitMoveNum:4}) },
    loading: { type: Boolean, default: false },
    hiddenLoading: { type: Boolean, default: false },
    disposalLoading: { type: Boolean, default: false },
    riskLoading: { type: Boolean, default: false },
  },
  data(){
    return{
      i18n: globalI18n,
      lang: globalI18n.getLang(),
    }
  },
  computed: {
    t() {
      void this.lang
      return this.i18n.t
    },
    handleRateData() {
      return [
        {
          name: this.t('handledPoint'),
          value: this.handledPoint || 0,
          color: '#6FC98F'
        },
        {
          name: this.t('unhandledPoint'),
          value: this.unhandledPoint || 0,
          color: '#CC6E6E'
        }
      ]
    }
  },
  mounted() {
    this.$root.$on('lang-change', () => {
      this.lang = this.i18n.getLang()
      this.$forceUpdate()
    })
  }
}
</script>

<style scoped lang="less">
.bottomCon{
  width: 100%;
  height: 100%;
  min-width: 1500px;
  min-height: 0;
  display: flex;
  gap: 10px;
}

.bottom{
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 0;
}

.getMore{
  width: 61px;
  height: 26px;
  background: rgba(42,98,255,0.1);
  border: 1px solid rgba(42,98,255,0.3);
  border-radius: 6px;
  line-height: 26px;
  text-align: center;
  color: var(--color-dark-text-accent, #8AB4FF);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4,0,0.2,1);

  &:hover {
    background: rgba(42,98,255,0.2);
    border-color: rgba(42,98,255,0.5);
    box-shadow: 0 0 12px rgba(42,98,255,0.15);
    color: #FFFFFF;
  }
}

.Part1{
  flex: 1.5;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;

  .hidden-box{
    flex: 1;
    height: 100%;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

    .hidden{
      flex: 1;
      width: 100%;
      min-height: 0;
      min-width: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;

      .hidden-pie {
        flex: 1;
        height: 100%;
        min-height: 0;
        min-width: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .hidden-stat {
        flex: 0.4;
        aspect-ratio: 1;
        min-height: 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        background: rgba(42, 54, 68, 0.4);
        border-radius: 8px;
        padding: 8px 6px;

        &__icon {
          width: 28px;
          height: 28px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: rgba(119, 168, 255, 0.1);
          border: 1px solid rgba(119, 168, 255, 0.25);

          svg {
            width: 16px;
            height: 16px;
          }
        }

        &__info {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1px;
        }

        &__value {
          font-family: "FROSTBITE-Narrow", sans-serif;
          font-size: 18px;
          line-height: 1;
          color: #FFFFFF;
        }

        &__label {
          font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
          font-size: 10px;
          color: rgba(255, 255, 255, 0.8);
          white-space: nowrap;
        }
      }
    }
}

/* ponytail: .hidden-list removed — each PieCard carries its own legend */

.Part2,
.Part4{
  flex: 2;

  .hr{
    width: 100%;
    height: 100%;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hr-pie{
    flex: 1;
    width: 0;
    min-width: 0;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .hr-list{
    flex: 1;
    width: 0;
    min-width: 0;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
  }

  .listCon2-header{
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    height: 28px;
    line-height: 28px;
    background: var(--color-dark-table-header, rgba(42,98,255,0.2));
    color: var(--color-dark-text-accent, #8AB4FF);
    font-size: 12px;
    display: flex;
    flex-shrink: 0;
    border-radius: 6px;
    .riskName{ width: 60%; padding-left: 10px; }
    .riskButton{ width: 40%; padding-left: 5px; text-align: center; cursor: default; }
  }

  .listCon2-scroll{
    flex: 1;
    width: 100%;
    overflow-y: auto;
  }

  .hr-list .listCon2 {
    height: 100%;
    overflow-y: auto;
  }
}

.listCon{
  margin-top: 4px;
  width: 520px;
  height: 274px;
  overflow: auto;
  margin-left: 30px;
}

.listCon2{
  width: 100%;
  height: calc(100% - 10px);
  overflow: hidden;
}

.listItem{
  > span{
    display: inline-block;
    vertical-align: center;
    line-height: 28px;
    height: 26px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.bluebg{
  background: var(--color-dark-table-header, rgba(42,98,255,0.2));
  color: var(--color-dark-text-accent, #8AB4FF);
  border-radius: 6px;
}
.firsp{
  width: 60px;
  text-align: center;
}
.secsp{
  width:150px;
}
.thisp{
  width: calc(100% - 310px);
}
.forsp{
  width: 80px;
}
.riskName{
  width: 80%;
  padding-left: 10px;
}
.riskButton{
  width: 20%;
  cursor: pointer;
}

.warp{
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

/* ponytail: .numFang replaced by IndexBadge component */

.trFont{
  margin-top: 10px;
  color: rgba(208, 222, 238, 1);
  border-bottom: 1px solid rgba(108, 128, 151, 0.50);
  font-size: 12px;
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
}

.Part3{
  flex: 2;
}

.Part4{
  flex: 1;
}

.staList{
  width: 581px;
  height: 350px;
  background-color: rgba(3, 15, 25, 0.70);
  position: absolute;
  top: 214px;
  left: 450px;
  background-image: url("../../assets/images/h5/tcbg.webp");
}

.staTitle{
  height: 44px;
  line-height: 44px;
  padding-left: 30px;
  color: var(--color-dark-text-accent, #8AB4FF);
  font-size: 16px;
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
  border-bottom: 3px solid #000;
}

.bignum{
  font-family: "FROSTBITE-Narrow", sans-serif;
  line-height: 22px;
  font-size: 16px;
  color: #FFFFFF;
}


.textFont{
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
  font-size: 12px;
  color: #FFFFFF;
  white-space: nowrap;
}

.point-clickable {
  cursor: pointer;

  &:hover {
    background: rgba(42, 98, 255, 0.08);
    border-radius: 4px;
  }
}

.pie-legend {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &__item {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 20px;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__name {
    flex: 1;
    font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__num {
    font-family: "FROSTBITE-Narrow", sans-serif;
    font-size: 12px;
    color: #FFFFFF;
    text-align: right;
  }
}
</style>
